import React, { useState } from "react";
import Modal from "../shared/Modal";
import "./ModalRequestCollection.css";

interface ModalRequestCollectionProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (title: string) => void;
}

export const ModalRequestCollection = ({
  isOpen,
  onClose,
  onSubmit,
}: ModalRequestCollectionProps) => {
  
    const [url, setUrl] = useState<string>("");

    const isValidURL = (string: string) : boolean => {
        const pattern = new RegExp(
            "^(?:(https?:\\/\\/)?"+  // Optional HTTP/HTTPS
            "((([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,})|" + // Domain name
            "localhost|" + // OR localhost
            "\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})" + // OR IPv4
            "(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?)$", // Port & Path
            "i"
          );

        return pattern.test(string);
      }
      
  const handleSubmit = () => {
    if (isValidURL(url)) {
      onSubmit(url);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={null}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-request-collection">
        <div className="modal-request-collection-title">
          <h2>Request a Public Collection</h2>
        </div>
        <div className="modal-request-collection-body">
          <div className="modal-request-collection-content">
            <input
                autoFocus=  {true}
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }
            }
              placeholder="Enter URL of the policy website you'd like us to consider."
            />
          </div>
        </div>
        <div className="modal-request-collection-buttons">
            <button
                onClick={onClose}
            >
                Cancel
            </button>
            <button
                onClick={handleSubmit}
                style={{backgroundColor: 'black', color: "white"}}
                disabled={!isValidURL(url)}
            >
                Submit
            </button>
        </div>
      </div>
    </Modal>
  );
};
